<template>
  <div class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
    <h3 class="text-lg font-bold text-[#0B2447] mb-4">
      Mes Catégories de Projets
    </h3>

    <!-- Ajouter une catégorie -->
    <div class="flex gap-2 mb-6">
      <input
        v-model="newCategoryName"
        @keyup.enter="addCategory"
        placeholder="Nouvelle catégorie (ex: Industrie)..."
        class="flex-1 p-2.5 text-sm border-2 border-gray-50 rounded-xl outline-none focus:border-orange-500 transition bg-gray-50"
      />
      <button
        @click="addCategory"
        class="bg-[#0B2447] hover:bg-orange-600 text-white px-6 rounded-xl font-bold transition"
      >
        +
      </button>
    </div>

    <!-- Liste des catégories -->
    <div v-if="categories.length > 0" class="flex flex-wrap gap-2">
      <div
        v-for="cat in categories"
        :key="cat.id"
        class="flex items-center gap-2 bg-gray-50 px-4 py-1.5 rounded-full border border-gray-100 group hover:border-orange-200 transition"
      >
        <span class="text-sm font-semibold text-gray-700">{{ cat.name }}</span>
        <button
          @click="deleteCategory(cat.id)"
          class="text-gray-400 hover:text-red-500 transition font-bold"
        >
          ×
        </button>
      </div>
    </div>
    <p v-else class="text-sm text-gray-400 italic">
      Aucune catégorie configurée.
    </p>
  </div>
</template>

<script>
import apiClient from '@/services/apiClient'

export default {
  name: 'CategorySettings',
  data() {
    return {
      categories: [],
      newCategoryName: ''
    }
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await apiClient.get('/api/v1/categories')
        this.categories = res.data
      } catch (err) {
        console.error('Erreur chargement catégories', err)
      }
    },
    async addCategory() {
      if (!this.newCategoryName.trim()) return
      try {
        const res = await apiClient.post('/api/v1/categories', {
          category: { name: this.newCategoryName }
        })
        this.categories.push(res.data)
        this.newCategoryName = ''
      } catch (err) {
        console.error('Erreur création catégorie', err)
      }
    },
    async deleteCategory(id) {
      try {
        await apiClient.delete(`/api/v1/categories/${id}`)
        this.categories = this.categories.filter((c) => c.id !== id)
      } catch (err) {
        console.error('Erreur suppression catégorie', err)
      }
    }
  },
  mounted() {
    this.fetchCategories()
  }
}
</script>
